import { render, staticRenderFns } from "./ClassroomAdd.vue?vue&type=template&id=c53bd794"
import script from "./ClassroomAdd.vue?vue&type=script&lang=js"
export * from "./ClassroomAdd.vue?vue&type=script&lang=js"
import style0 from "./ClassroomAdd.vue?vue&type=style&index=0&id=c53bd794&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports